<template>
  <div class="vp-container">
    <div class="vp-left">
      <div class="case-select">
        <!-- 复原：病例下拉选择 CASE1 CASE2 CASE3 -->
        <select v-model="currentCaseId" @change="handleCaseChange">
          <option value="case01">CASE1</option>
          <option value="case02">CASE2</option>
          <option value="case03">CASE3</option>
        </select>

        <div class="case-item">
          <!-- 折叠标题栏 -->
          <div class="case-header" @click="caseExpand = !caseExpand">
            <h4>{{ $i18n?.caseTitle || $langStore.dict[$langStore.currentLang].caseTitle }}</h4>
            <span class="arrow-icon">{{ caseExpand ? '▼' : '▶' }}</span>
          </div>
          <!-- 病例详情区域 -->
          <div class="case-body" v-show="caseExpand">
            <p><b>{{ $langStore.dict[$langStore.currentLang].baseInfo }}：</b>{{ caseInfo.base }}</p>
            <p><b>{{ $langStore.dict[$langStore.currentLang].chiefComplaint }}：</b>{{ caseInfo.chief }}</p>
            <p><b>{{ $langStore.dict[$langStore.currentLang].presentHistory }}：</b>{{ caseInfo.present }}</p>
            <p><b>{{ $langStore.dict[$langStore.currentLang].operationRecord }}：</b>{{ caseInfo.operation }}</p>
            <p><b>{{ $langStore.dict[$langStore.currentLang].currentStage }}：</b>{{ caseInfo.stage }}</p>
          </div>
        </div>
      </div>
      <div class="tip-text">
        {{ $langStore.dict[$langStore.currentLang].tipText }}
      </div>
    </div>

    <div class="vp-right">
      <div class="chat-box">
        <div class="msg-list" ref="scrollWrap">
          <div class="msg-item" :class="item.role" v-for="(item,idx) in msgArr" :key="idx">
            <div class="msg-avatar">
              {{ item.role === 'student' ? $langStore.dict[$langStore.currentLang].roleStudent : $langStore.dict[$langStore.currentLang].roleTutor }}
            </div>
            <div class="msg-content">{{ item.content }}</div>
          </div>
        </div>
        <div class="chat-input-area">
          <input v-model="inputText" :placeholder="$langStore.dict[$langStore.currentLang].inputPlaceholder" type="text" @keyup.enter="sendMsg"/>
          <button @click="sendMsg" :disabled="loading">{{ $langStore.dict[$langStore.currentLang].btnSend }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiVpChat, apiVpHistory, apiVpCaseBaseline } from '@/api/virtualPatient'

export default {
  name: "VirtualPatient",
  data() {
    return {
      currentCaseId: "case01",
      loading: false,
      caseExpand: true, // 折叠状态，true默认展开
      caseInfo: {
        base: "",
        chief: "",
        present: "",
        operation: "",
        stage: ""
      },
      inputText: "",
      msgArr: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loadCaseInfo()
      this.loadHistoryChat()
    })
  },
  watch: {
    '$langStore.currentLang'(newVal, oldVal) {
      console.log('语言切换：', oldVal, ' → ', newVal)
      if (newVal !== oldVal) {
        this.resetChat()
        this.$nextTick(() => {
          this.loadCaseInfo()
        })
      }
    }
  },
  methods: {
    //下拉切换病例
    handleCaseChange(){
      this.resetChat()
      this.$nextTick(()=>{
        this.loadCaseInfo()
        this.loadHistoryChat()
      })
    },

    async loadCaseInfo() {
      try {
        const res = await apiVpCaseBaseline({
          case_id: this.currentCaseId,
          lang: this.$langStore.currentLang
        })
        if (res.code === 200) {
          const text = res.data.baseline || ""
          const lang = this.$langStore.currentLang
          const lines = text.split('\n').map(s => s.trim()).filter(s => s)

          this.caseInfo.base = ""
          this.caseInfo.chief = ""
          this.caseInfo.present = ""
          this.caseInfo.operation = ""
          this.caseInfo.stage = ""

          if(lang === "zh"){
            lines.forEach(line => {
              if(line.startsWith("患者：")){
                this.caseInfo.base = line.replace("患者：","").trim()
              }else if(line.startsWith("主诉：")){
                this.caseInfo.chief = line.replace("主诉：","").trim()
              }else if(line.startsWith("现病史：")){
                this.caseInfo.present = line.replace("现病史：","").trim()
              }else if(line.startsWith("手术记录：")){
                this.caseInfo.operation = line.replace("手术记录：","").trim()
              }else if(line.startsWith("当前阶段：")){
                this.caseInfo.stage = line.replace("当前阶段：","").trim()
              }
            })
          }else{
            lines.forEach(line => {
              if(line.startsWith("Basic Info:")){
                this.caseInfo.base = line.replace("Basic Info:","").trim()
              }else if(line.startsWith("Chief Complaint:")){
                this.caseInfo.chief = line.replace("Chief Complaint:","").trim()
              }else if(line.startsWith("Present Illness:")){
                this.caseInfo.present = line.replace("Present Illness:","").trim()
              }else if(line.startsWith("Surgical Procedure:")){
                this.caseInfo.operation = line.replace("Surgical Procedure:","").trim()
              }else if(line.startsWith("Current Phase:")){
                this.caseInfo.stage = line.replace("Current Phase:","").trim()
              }
            })
          }
        }
      } catch (err) {
        this.$message.error("加载病例基线信息失败")
        console.error(err)
      }
    },

    async loadHistoryChat() {
      try {
        const res = await apiVpHistory({ case_id: this.currentCaseId })
        if (res.code === 200) {
          this.msgArr = res.data.map(item => {
            return {
              role: item.role === "user" ? "student" : "ai",
              content: item.content
            }
          })
        }
      } catch (err) {
        this.$message.error("加载对话历史失败")
      }
      this.$nextTick(() => {
        if(this.$refs.scrollWrap){
          this.$refs.scrollWrap.scrollTop = this.$refs.scrollWrap.scrollHeight
        }
      })
    },

    async sendMsg() {
      if (!this.inputText.trim()) {
        this.$message.warning("消息不能为空")
        return
      }
      this.loading = true
      const sendText = this.inputText.trim()
      this.msgArr.push({
        role: "student",
        content: sendText
      })
      this.inputText = ""
      this.$nextTick(() => {
        if(this.$refs.scrollWrap){
          this.$refs.scrollWrap.scrollTop = this.$refs.scrollWrap.scrollHeight
        }
      })

      try {
        const res = await apiVpChat({
          case_id: this.currentCaseId,
          user_msg: sendText,
          lang: this.$langStore.currentLang
        })
        if (res.code === 200) {
          this.msgArr.push({
            role: "ai",
            content: res.data.ai_reply
          })
        }
      } catch (err) {
        this.$message.error("大模型对话请求失败，请检查API密钥和网络")
      } finally {
        this.loading = false
        this.$nextTick(() => {
          if(this.$refs.scrollWrap){
            this.$refs.scrollWrap.scrollTop = this.$refs.scrollWrap.scrollHeight
          }
        })
      }
    },

    resetChat() {
      this.msgArr = []
      this.inputText = ""
      this.caseExpand = true //切换病例/语言，重置为展开状态
      this.caseInfo = {
        base: "",
        chief: "",
        present: "",
        operation: "",
        stage: ""
      }
    }
  }
}
</script>

<style scoped>
.vp-container{
  display:flex;
  gap:20px;
  height: 100%;
}
.vp-left{
  width:420px;
  background:#fff;
  padding:16px;
  border-radius:8px;
  overflow-y:auto;
  border:1px solid #e4e7ed;
}
.case-select{
  margin-bottom:14px;
}
/* 下拉框简单样式 */
.case-select select{
  width:100%;
  padding:6px;
  margin-bottom:10px;
}
.case-item{
  margin-bottom:12px;
  padding:8px;
  border:1px solid #eee;
  border-radius:4px;
}
.case-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  cursor:pointer;
  user-select:none;
}
.arrow-icon{
  font-size:14px;
  color:#666;
}
.case-body{
  margin-top:8px;
}
.tip-text{
  margin-top:20px;
  color:#888;
  font-size:13px;
  text-align:center;
}

.vp-right{
  flex:1;
  background:#fff;
  padding:16px;
  border-radius:8px;
  border:1px solid #e4e7ed;
  display:flex;
  flex-direction:column;
}
.chat-box{
  flex:1;
  display:flex;
  flex-direction:column;
  height:100%;
}
.msg-list{
  flex:1;
  overflow-y:auto;
  margin-bottom:12px;
}
.msg-item{
  margin:10px 0;
}
.msg-item.student{
  text-align:right;
}
.msg-item.ai{
  text-align:left;
}
.msg-avatar{
  font-size:13px;
  color:#666;
  margin-bottom:4px;
}
.msg-content{
  display:inline-block;
  padding:10px 14px;
  border-radius:8px;
  max-width:75%;
}
.msg-item.student .msg-content{
  background:#409eff;
  color:#fff;
}
.msg-item.ai .msg-content{
  background:#e8edf7;
  color:#222;
}

.chat-input-area{
  display:flex;
  gap:8px;
}
.chat-input-area input{
  flex:1;
  padding:10px;
}
</style>
